import { Box, Typography } from "@material-ui/core";

const RenderAccordionDetail = ({ label, value, suffix = "", classes }) => {
    return (
        <Box className={classes.displayFlex}>
            <Typography className={`${classes.txtSubtitleBlue} ${classes.txtEllipsis}`}>
                {label}
            </Typography>
            <Typography
                className={`${classes.txtSubtitleGray} ${classes.txtEllipsis}`}
                style={{ marginLeft: "5px" }}
            >
                {value + suffix}
            </Typography>
        </Box>
    );
};

export default RenderAccordionDetail;
